import { render } from "./route-tree.vue?vue&type=template&id=2fd3eef0"
import script from "./route-tree.vue?vue&type=script&lang=js"
export * from "./route-tree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__